import materialUrlConstants from '../../constants/materialUrlConstants'
import reportsUrls from './reportsUrls'

const getMaterialUrls = () => materialUrlConstants.ADDITIONAL_MATERIALS
const getReportMaterialsUrl = (reportId: number) =>
  `${reportsUrls.reports()}${reportId}/additionalmaterials`

const getFileIdUrl = (fileId: number) => `${materialUrlConstants.FILES}/${fileId}/`
const getFilesUrl = () => materialUrlConstants.FILES

export default { getMaterialUrls, getReportMaterialsUrl, getFileIdUrl, getFilesUrl }
